import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import MapView from '@arcgis/core/views/MapView';
import { Tool, ToolSlot } from '../framework/Tool';
import { SurfaceDef } from '../model/SurfaceDef';
import { EditTinablePointsInputTask } from './EditTinablePointsInputTask';
import stores from 'cd-eft/models/Stores';

const setStore = stores.AppStore.surveyEngineeringStore;

export class EditTinablePointsTool extends Tool {
  private readonly mapView: MapView;
  private readonly surfaceDef: SurfaceDef;
  private task: EditTinablePointsInputTask;
  private groundPointsLayer: GraphicsLayer;

  constructor(mapView: MapView, surfaceDef: SurfaceDef, toolSlot: ToolSlot, groundPointsLayer: GraphicsLayer) {
    super('Edit Ground Point', 'continuous', toolSlot);
    this.mapView = mapView;
    this.surfaceDef = surfaceDef;
    this.task = new EditTinablePointsInputTask(this.mapView, this.surfaceDef);
    this.groundPointsLayer = groundPointsLayer;
  }

  protected async onExecuteOperation(): Promise<void> {
    await this.task.executeTaskAsync();
  }

  protected async onCancelOperation(): Promise<void> {
    if (this.task.isExecuting) {
      await this.task.cancelTaskAsync();
    }
  }
}
